import { render, staticRenderFns } from "./OrderActionMarkAsPaid.vue?vue&type=template&id=437347d8&"
import script from "./OrderActionMarkAsPaid.vue?vue&type=script&lang=ts&"
export * from "./OrderActionMarkAsPaid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports